/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션

**주요 개선사항:**
- 모든 Thymeleaf 페이지를 REST API로 변환
- 기능별 그룹화된 경로 구조
- 표준화된 응답 형식
- React SPA 완전 지원

**API 구조:**
- 결제수단 관리: `/api/v1/payment-methods/*`
- 구독 관리: `/api/v1/subscriptions/*` 
- 플랜 관리: `/api/v1/plans/*`
- 주문 관리: `/api/v1/orders/*`
- 대시보드: `/api/v1/dashboard/*`
- NicePay 결제: `/api/v1/payment/nicepay/*`
- 세션 관리: `/api/v1/auth/*`

 * OpenAPI spec version: 2.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  AdminAccountActionResponse,
  AdminAccountCancelSubscriptionRequest,
  AdminAccountPaymentDebugResponse,
  AdminAccountPaymentSummaryResponse,
  AdminAccountRefundRequest,
  AdminDebugSubscription200,
  ErrorResponse,
  GetAdminAccountPaymentDebugParams,
  GetAdminAccountPaymentSummariesParams,
  GetAdminUserSubscriptions200Response,
} from "./paymentServiceAPI.schemas";
import { customInstance } from "../custom-axios";
import type { ErrorType } from "../custom-axios";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary 관리자용 사용자 구독 조회 (v2)
 */
export const getAdminUserSubscriptionsV2 = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetAdminUserSubscriptions200Response>(
    {
      url: `/api/v1/admin/users/${userId}/subscriptions`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetAdminUserSubscriptionsV2QueryKey = (userId: string) => {
  return [`/api/v1/admin/users/${userId}/subscriptions`] as const;
};

export const getGetAdminUserSubscriptionsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminUserSubscriptionsV2QueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>
  > = ({ signal }) =>
    getAdminUserSubscriptionsV2(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminUserSubscriptionsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>
>;
export type GetAdminUserSubscriptionsV2QueryError = ErrorType<unknown>;

/**
 * @summary 관리자용 사용자 구독 조회 (v2)
 */
export const useGetAdminUserSubscriptionsV2 = <
  TData = Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminUserSubscriptionsV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAdminUserSubscriptionsV2QueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * 특정 사용자의 현재 구독 상태와 최근 주문 기록을 조회합니다.
 * @summary 관리자용 계정 결제 디버그 조회
 */
export const getAdminAccountPaymentDebug = (
  params: GetAdminAccountPaymentDebugParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AdminAccountPaymentDebugResponse>(
    {
      url: `/api/v1/admin/accounts/payment-debug`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetAdminAccountPaymentDebugQueryKey = (
  params: GetAdminAccountPaymentDebugParams,
) => {
  return [
    `/api/v1/admin/accounts/payment-debug`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminAccountPaymentDebugQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAdminAccountPaymentDebugParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminAccountPaymentDebugQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>
  > = ({ signal }) =>
    getAdminAccountPaymentDebug(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminAccountPaymentDebugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>
>;
export type GetAdminAccountPaymentDebugQueryError = ErrorType<ErrorResponse>;

/**
 * @summary 관리자용 계정 결제 디버그 조회
 */
export const useGetAdminAccountPaymentDebug = <
  TData = Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAdminAccountPaymentDebugParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminAccountPaymentDebug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAdminAccountPaymentDebugQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * 사용자 목록에 표시할 앱별 구독 요약을 일괄 조회합니다.
 * @summary 관리자용 계정 결제 요약 조회
 */
export const getAdminAccountPaymentSummaries = (
  params: GetAdminAccountPaymentSummariesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AdminAccountPaymentSummaryResponse[]>(
    {
      url: `/api/v1/admin/accounts/payment-summaries`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetAdminAccountPaymentSummariesQueryKey = (
  params: GetAdminAccountPaymentSummariesParams,
) => {
  return [
    `/api/v1/admin/accounts/payment-summaries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminAccountPaymentSummariesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAdminAccountPaymentSummariesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminAccountPaymentSummariesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>
  > = ({ signal }) =>
    getAdminAccountPaymentSummaries(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminAccountPaymentSummariesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>
>;
export type GetAdminAccountPaymentSummariesQueryError =
  ErrorType<ErrorResponse>;

/**
 * @summary 관리자용 계정 결제 요약 조회
 */
export const useGetAdminAccountPaymentSummaries = <
  TData = Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetAdminAccountPaymentSummariesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminAccountPaymentSummaries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAdminAccountPaymentSummariesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * 특정 사용자의 주문에 대해 관리자 권한으로 환불 요청을 생성합니다.
 * @summary 관리자용 환불 요청 생성
 */
export const requestAdminAccountRefund = (
  adminAccountRefundRequest: AdminAccountRefundRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AdminAccountActionResponse>(
    {
      url: `/api/v1/admin/accounts/refund-request`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: adminAccountRefundRequest,
    },
    options,
  );
};

export const getRequestAdminAccountRefundMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAdminAccountRefund>>,
    TError,
    { data: AdminAccountRefundRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestAdminAccountRefund>>,
  TError,
  { data: AdminAccountRefundRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestAdminAccountRefund>>,
    { data: AdminAccountRefundRequest }
  > = (props) => {
    const { data } = props ?? {};

    return requestAdminAccountRefund(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestAdminAccountRefundMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestAdminAccountRefund>>
>;
export type RequestAdminAccountRefundMutationBody = AdminAccountRefundRequest;
export type RequestAdminAccountRefundMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 관리자용 환불 요청 생성
 */
export const useRequestAdminAccountRefund = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAdminAccountRefund>>,
    TError,
    { data: AdminAccountRefundRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestAdminAccountRefund>>,
  TError,
  { data: AdminAccountRefundRequest },
  TContext
> => {
  const mutationOptions = getRequestAdminAccountRefundMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * 특정 사용자의 특정 구독을 관리자 권한으로 취소합니다.
 * @summary 관리자용 구독 취소
 */
export const cancelAdminAccountSubscription = (
  adminAccountCancelSubscriptionRequest: AdminAccountCancelSubscriptionRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AdminAccountActionResponse>(
    {
      url: `/api/v1/admin/accounts/cancel-subscription`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: adminAccountCancelSubscriptionRequest,
    },
    options,
  );
};

export const getCancelAdminAccountSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAdminAccountSubscription>>,
    TError,
    { data: AdminAccountCancelSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelAdminAccountSubscription>>,
  TError,
  { data: AdminAccountCancelSubscriptionRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelAdminAccountSubscription>>,
    { data: AdminAccountCancelSubscriptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return cancelAdminAccountSubscription(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelAdminAccountSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelAdminAccountSubscription>>
>;
export type CancelAdminAccountSubscriptionMutationBody =
  AdminAccountCancelSubscriptionRequest;
export type CancelAdminAccountSubscriptionMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary 관리자용 구독 취소
 */
export const useCancelAdminAccountSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAdminAccountSubscription>>,
    TError,
    { data: AdminAccountCancelSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelAdminAccountSubscription>>,
  TError,
  { data: AdminAccountCancelSubscriptionRequest },
  TContext
> => {
  const mutationOptions =
    getCancelAdminAccountSubscriptionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * 특정 사용자의 모든 구독을 조회합니다 (중복 구독 확인용)
 * @summary 관리자용 사용자 구독 조회
 */
export const getAdminUserSubscriptions = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetAdminUserSubscriptions200Response>(
    {
      url: `/api/v1/admin/subscriptions/users/${userId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetAdminUserSubscriptionsQueryKey = (userId: string) => {
  return [`/api/v1/admin/subscriptions/users/${userId}`] as const;
};

export const getGetAdminUserSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminUserSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminUserSubscriptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminUserSubscriptionsQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminUserSubscriptions>>
  > = ({ signal }) => getAdminUserSubscriptions(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminUserSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminUserSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminUserSubscriptions>>
>;
export type GetAdminUserSubscriptionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary 관리자용 사용자 구독 조회
 */
export const useGetAdminUserSubscriptions = <
  TData = Awaited<ReturnType<typeof getAdminUserSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminUserSubscriptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAdminUserSubscriptionsQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * 구독의 상세 디버그 정보를 조회합니다
 * @summary 관리자용 구독 디버그
 */
export const adminDebugSubscription = (
  subscriptionId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AdminDebugSubscription200>(
    {
      url: `/api/v1/admin/subscriptions/${subscriptionId}/debug`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getAdminDebugSubscriptionQueryKey = (subscriptionId: string) => {
  return [`/api/v1/admin/subscriptions/${subscriptionId}/debug`] as const;
};

export const getAdminDebugSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDebugSubscription>>,
  TError = ErrorType<ErrorResponse>,
>(
  subscriptionId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminDebugSubscription>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminDebugSubscriptionQueryKey(subscriptionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminDebugSubscription>>
  > = ({ signal }) =>
    adminDebugSubscription(subscriptionId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!subscriptionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDebugSubscription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminDebugSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDebugSubscription>>
>;
export type AdminDebugSubscriptionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary 관리자용 구독 디버그
 */
export const useAdminDebugSubscription = <
  TData = Awaited<ReturnType<typeof adminDebugSubscription>>,
  TError = ErrorType<ErrorResponse>,
>(
  subscriptionId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminDebugSubscription>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAdminDebugSubscriptionQueryOptions(
    subscriptionId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
